import styled from "styled-components";

import { easingSeconds } from "core/animation";
import colors from "core/colors";
import Flexbox from "core/Flexbox";

import Twitter from "core/jsSvgIcons/Twitter";

export const SocialsWrapper = styled(Flexbox)`
    ${Twitter} {
        margin-left: 13px;
    }

    svg {
        transition: opacity ${easingSeconds};

        &:hover {
            opacity: 0.6;
        }
    }
`;

export const TextWrapper = styled.div`
    color: ${colors.mist};
`;

export const Wrapper = styled.div`
    width: 100%;
    padding: 1rem;

    ${TextWrapper} {
        margin-left: 1rem;
    }

    ${SocialsWrapper} {
        margin-left: 10px;
    }
`;
